import request from '@/utils/http';


export function getCategory() {
  return request('/home/category/head');
}
// 查询轮播图
export function getBanners() {
  return request('/mall/general/findBanner');
}


export function getNews() {
  return request('/home/new');
}

export function getHot() {
  return request('/home/hot');
}
// 合作品牌
export function findBrand() {
  return request('/mall/general/findBrand');
}

// 合作伙伴
export function findPartner() {
  return request('/mall/general/findPartner');
}
// 查询首页商品分类
export function findCategoryPro() {
  return request('/mall/general/findCategoryPro');
}